var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCommentDots = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.496,
    viewBox: "0 0 20 17.496",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "comment-dots",
    d: "M1.125,40.123c0-3.569,3.663-6.873,8.748-6.873s8.748,3.3,8.748,6.873S14.958,47,9.873,47a11.342,11.342,0,0,1-3.651-.633,1.273,1.273,0,0,0-1.14.164,11.029,11.029,0,0,1-1.89,1.07l.246.57-.25-.574a8.532,8.532,0,0,1-1.277.449c.02-.035.043-.07.062-.1a7.3,7.3,0,0,0,1-2.98,1.23,1.23,0,0,0-.289-.933A6.083,6.083,0,0,1,1.125,40.123ZM9.873,32c-5.526,0-10,3.64-10,8.123a7.333,7.333,0,0,0,1.851,4.706s0,0,0,.008A6.038,6.038,0,0,1,.9,47.3a5.869,5.869,0,0,1-.847,1.133A.623.623,0,0,0,.5,49.5a8.249,8.249,0,0,0,3.187-.754,12.087,12.087,0,0,0,2.1-1.191.034.034,0,0,1,.027,0,12.69,12.69,0,0,0,4.058.7c5.526,0,10-3.64,10-8.123S15.4,32,9.873,32Zm-5,9.06a.937.937,0,1,0-.937-.937A.937.937,0,0,0,4.874,41.06Zm5,0a.937.937,0,1,0-.937-.937A.937.937,0,0,0,9.873,41.06Zm5.936-.937a.937.937,0,1,0-.937.937A.937.937,0,0,0,15.809,40.123Z",
    transform: "translate(0.13 -32)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCommentDots);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/comment-dots.562993561e0b61fcf817ecad21f3a109.svg";